// src/client/screens/auth/SplashScreen.tsx
// Mounted on '/'. Auto-routes:
//   - status loading → keep showing logo
//   - signed_out → /login
//   - signed_in + kyc !== verified → /kyc
//   - signed_in + verified → /home
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';
import { useAuth } from '@client/auth/useAuth';
import Logo from '@client/components/Logo';

export default function SplashScreen() {
  const { status, profile } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === 'loading') return;
    if (status === 'signed_out') {
      navigate(ROUTES.login, { replace: true });
      return;
    }
    if (profile && profile.kyc_status !== 'verified') {
      navigate(ROUTES.kyc, { replace: true });
      return;
    }
    navigate(ROUTES.home, { replace: true });
  }, [status, profile, navigate]);

  return (
    <div role="status" aria-live="polite" style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', minHeight: '100dvh', gap: 16,
    }}>
      <Logo size={96} />
      <h1>Thandizo</h1>
      <p className="small">Loading…</p>
    </div>
  );
}
